import React from 'react';
import { ChatProvider } from './contexts/ChatContext';
import ChatInterface from './components/ChatInterface';
import './App.css';

const App: React.FC = () => {
  return (
    <ChatProvider>
      <div className="App">
        <ChatInterface />
      </div>
    </ChatProvider>
  );
};

export default App;
